import React from 'react';

function QuizOutro({ outroText, candle, onRedirect }) {
    return (
        <div>
            <p className="quiz-outro-text">{outroText}</p>
            {candle && (
                <div className="quiz-outro-candle-wrapper">
                    <div 
                        className="candle-option selected" 
                        style={{ cursor: 'pointer' }}
                        onClick={onRedirect}
                        role="button"
                        tabIndex={0}
                    >
                        <img src={candle.image} alt={candle.name} />
                        <span>{candle.name}</span>
                    </div>
                </div>
            )}
            <div className="quiz-intro-button-wrapper">
                <button className="btn" onClick={onRedirect}>Chcę zapalić Wirtualny Znicz</button>
            </div>
        </div>
    );
}

export default QuizOutro;
